$(document).ready(function(){
  $('.faqs_wrapp .faqs_blocks_wrap .faqs_block .quetion').click(function(){
    if($(this).parent('.faqs_block').hasClass('active')){
      $(this).siblings('.answer').slideUp();
      $(this).parent('.faqs_block').removeClass('active');
    }else{
      $(this).parent('.faqs_block').addClass('active');
      $(this).siblings('.answer').slideDown();
    }
  });

  $(".pro_custom-pro-rec_meta .pro_custom-pro-rec_meta-main").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows:false,
    dots:true,
    prevArrow:"<button type='button' class='slick-prev'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-caret' viewBox='0 0 10 6'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z' fill='currentColor'></svg></button>",
    nextArrow:"<button type='button' class='slick-next'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-caret' viewBox='0 0 10 6'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z' fill='currentColor'></svg></button>",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  });


  $(".section-faq-tab .que-ans-li .que").click(function(){
    if($(this).next().hasClass("active-ans"))
    {
      $(this).next().removeClass("active-ans");
      $(this).next().slideUp(300);
      $(this).children(".icon-block").removeClass("icon-block-active");
    }
    else{
      $(".section-faq-tab .que-ans-block .que-ans-li .ans").removeClass("active-ans");
      $(".section-faq-tab .que-ans-block .que-ans-li .ans").slideUp(300);
      $(".section-faq-tab .que-ans-block .que-ans-li .icon-block").removeClass("icon-block-active");
      $(this).next().addClass("active-ans");
      $(this).next().slideDown(300);
      $(this).children(".icon-block").addClass("icon-block-active");

    }
  });

// For Recharge 
  
  var cust_subscription_html = $('#subscription_custm_data.subscription_custm_data');
  $('#subscription_custm_data.subscription_custm_data').remove();
  $(document).on('click','.subscription_custm_data .subscription_popup_label,.subscription_popup .subscription_popup_content .close_popup,.subscription_popup .subscription_popup_wrap ',function(){
    $('#subscription_popup.subscription_popup').fadeToggle();
  });
  $(document).on('click','#subscription_popup.subscription_popup .subscription_popup_wrap .subscription_popup_content',function(e){
    e.stopPropagation();
  });

  var subscribe_interval = setInterval(function(){
    if($('.rc-container-wrapper').length){
      clearInterval(subscribe_interval);
      $('.rc-container-wrapper .rc-widget .rc-radio.rc-option__subsave').append(cust_subscription_html);
      $('.rc-widget .rc-radio__label .rc-option__discount').append(' OFF')
      $('.rc-widget .rc-radio .rc-radio__input:checked').trigger('change');
    }
  }, 100);

  function sticky_price_change(){
      $('.sticky_cart_wrap .sticky_cart_row .sticky_button_wrapp .product-form__submit .btn_price_wrap').html($('.product .product__info-wrapper .product-form__buttons .product-form__submit .btn_price_wrap').html());
      $('.sticky_cart_wrap .sticky_cart_row .sticky_main_price').html($('.product .product__info-wrapper .product_main_price').html());
  }
  
  $(document).on('change','.rc-widget .rc-radio .rc-radio__input',function(){
    if($(this).val() == 'subsave'){
      $('.product .product__info-wrapper .product-form__buttons').addClass('subscribe_btn_wrap');
      $('.sticky_cart_wrap .sticky_cart_row .sticky_button_wrapp').addClass('subscribe_btn_wrap');
      $('.product .product__info-wrapper variant-radios .product-form__input[data-opt_handle="quantity"]').hide();
      $('.product .product__info-wrapper variant-radios .product-form__input[data-opt_handle="quantity"]').find('label').eq(0).trigger('click');
      $('.product .product__info-wrapper .subscribe_variant_text_wrap').hide();
      $('.product .product__info-wrapper .product_form_after_pay').hide();
    }else{
      $('.product .product__info-wrapper .product-form__buttons').removeClass('subscribe_btn_wrap');
      $('.sticky_cart_wrap .sticky_cart_row .sticky_button_wrapp').removeClass('subscribe_btn_wrap');
      $('.product .product__info-wrapper variant-radios .product-form__input[data-opt_handle="quantity"]').show();
      $('.product .product__info-wrapper .subscribe_variant_text_wrap').show();
      $('.product .product__info-wrapper .product_form_after_pay').show();
    }
    setTimeout(sticky_price_change,1200);
  });

  $(document).on('change','.product .product__info-container .product-form__input input[type=radio]',function(){
    if($('.rc-container-wrapper').length){
      setTimeout(sticky_price_change,1200);
    }
  });

  $('.mobile-facets__header .close-facet').click(function () {
    $('.mobile-facets__open-wrapper').click();
    setTimeout(function() {$('#FacetFiltersFormMobile').removeClass('open_sort');},500)
  });

   $(document).on('click','.mega-menu-back',function() {
         // $('this').parents('.mob_megamenu_image_inner').toggleClass('active-btn');
  });
  
});